export default [
    {
        path: '/hero',
        name: 'hero',
        component: () => import('@/views/menu/hero/hero.vue'),
        meta: {
            pageTitle: 'مدیریت رکوردداران',
            action: 'show',
            resource: 'HeroManagment',
        },
    },
    {
        path: '/herocomment',
        name: 'herocomment',
        component: () => import('@/views/menu/hero/comment/herocomment.vue'),
        meta: {
            pageTitle: 'مدیریت نظرهای رکوردداران',
            action: 'show',
            resource: 'HeroComment',
        },
    },
]